import { LOCALE_ID, Provider } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeEn from '@angular/common/locales/en';
import localeDe from '@angular/common/locales/de';

/**
 * LOCALE_ID stays 'de': our customNumber pipe uses it as the default base
 * from which it further manipulates the number.
 *
 * We also register the 'en' locale data so DatePipe can format named parts
 * (e.g. month names) in the current UI language, which customDate passes
 * explicitly rather than relying on LOCALE_ID.
 */
export const localeProvider: Provider = {
	provide: LOCALE_ID,
	useFactory: () => {
		registerLocaleData(localeDe);
		registerLocaleData(localeEn);
		return 'de';
	},
};
